import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '#environments';
import { inject, Injectable } from '@angular/core';
import { Dtos } from '#models';

@Injectable({
  providedIn: 'root',
})
export class SubAreaService {
  private http = inject(HttpClient);

  public getAll(): Observable<Dtos.SubArea[]> {
    return this.http.get<Dtos.SubArea[]>(`${environment.apiUrl}/sub-area`);
  }

  public getAllByAreaId(areaId: number): Observable<Dtos.SubArea[]> {
    return this.http.get<Dtos.SubArea[]>(`${environment.apiUrl}/sub-area/getByArea/${areaId}`);
  }

  public getSubAreaById(id: number): Observable<Dtos.SubArea> {
    return this.http.get<Dtos.SubArea>(`${environment.apiUrl}/sub-area/${id}`);
  }

  public createSubArea(area: Dtos.SubArea): Observable<Dtos.SubArea> {
    return this.http.post<Dtos.SubArea>(`${environment.apiUrl}/sub-area`, area);
  }

  public updateSubArea(area: Dtos.SubArea): Observable<Dtos.SubArea> {
    return this.http.put<Dtos.SubArea>(`${environment.apiUrl}/sub-area`, area);
  }

  public deleteSubArea(id: number): Observable<Dtos.SubArea> {
    return this.http.put<Dtos.SubArea>(`${environment.apiUrl}/sub-area/delete/${id}`, null);
  }

  public activateSubArea(id: number): Observable<Dtos.SubArea> {
    return this.http.put<Dtos.SubArea>(`${environment.apiUrl}/sub-area/${id}/activate`, null);
  }
}
